// @ts-nocheck
import React from 'react';
import _ from 'lodash';
import Card from '@material-ui/core/Card';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import InfiniteScroll from 'react-infinite-scroller';
import { CircularProgress, createTheme, IconButton, withStyles } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import { BLUE, CUSTOM_ACTION_BUTTONS_ICONS, CUSTOM_FIELDS_TYPES_ICONS, GREEN, RED } from '../../_config/consts';
import CustomFieldsIconCustom from '../CustomIcons/CustomFieldsIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import { Apps } from '@material-ui/icons';

const styles = theme => ({
  container: {
    overflowY: 'auto',
    height: '120vh',
    paddingLeft: 15,
    paddingBottom: 220,
    paddingRight: 20,
    paddingTop: 0,
  },
  rowContainer: {
    padding: 20,
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    marginBottom: 15,
  },
  rowTitle: {
    fontWeight: 'bold',
    color: '#3f3f3f',
    margin: 0,
  },
  rowDescription: {
    color: '#3f3f3f',
    margin: 0,
    fontSize: 16,
  },
  rowBody: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 5,
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

const EmptyCustomFieldsView = ({ onCreateNew }) => (
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: 20, marginTop: 50, marginRight: 50 }}>
    <Apps style={{ color: '#bdbdbd', fontSize: 50, alignSelf: 'center' }} />
    <h3 style={{ color: '#bdbdbd', fontWeight: 'bold', textAlign: 'center', marginTop: 0 }}><Entity entity="noCustomExploreButtonsFound" /></h3>
    <h4 style={{ color: '#bdbdbd', fontWeight: 'normal',lineHeight: '1.3em', textAlign: 'center', marginTop: 0 }}><Entity entity="customExploreButtonsDescription" /></h4>
    <MDButton
      title={<Entity entity="createNewCustomField" />}
      titleStyle={{ marginTop: 0, fontSize: 13 }}
      backgroundColor={GREEN}
      containerStyle={{ margin: 0, marginTop: 10 }}
      onClick={() => onCreateNew()}
    />
  </div>
);

const CustomFieldRow = ({ customField, classes, onRowClick, onDeleteClick }) => {
  const onHandleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDeleteClick) {
      onDeleteClick(customField);
    }
  };

  const renderActionDescription = () => {
    if (customField.action === 'OPEN_NATIVE_VIEW') {
      return (
        <div>
          <h4 className={classes.rowDescription} style={{ marginRight: 5, marginTop: 5, marginBottom: 5 }}>
            <Entity entity="customExploreButonsActions" data={{ type: customField.action }} />
          </h4>
          {customField.viewName ? (
            <h4 className={classes.rowDescription} style={{ marginTop: 2, fontSize: 14, color: '#757575' }}>
              {`View: ${customField.viewName}`}
            </h4>
          ) : null}
          {customField.viewParams && customField.viewParams.length > 0 ? (
            <h4 className={classes.rowDescription} style={{ marginTop: 2, fontSize: 14, color: '#757575' }}>
              {`Parameters: ${customField.viewParams.join(', ')}`}
            </h4>
          ) : null}
        </div>
      );
    } else if (customField.action === 'URL_WEBVIEW' || customField.action === 'URL_EXT_BROWSER') {
      return (
        <div>
          <h4 className={classes.rowDescription} style={{ marginRight: 5, marginTop: 5, marginBottom: 5 }}>
            <Entity entity="customExploreButonsActions" data={{ type: customField.action }} />
          </h4>
          {customField.url ? (
            <h4 className={classes.rowDescription} style={{ marginTop: 2, fontSize: 14, color: '#757575' }}>
              {customField.url}
            </h4>
          ) : null}
        </div>
      );
    }
    return null;
  };

  return (
    <Card className={`card card-rounded ${classes.rowContainer}`} onClick={() => onRowClick()}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {customField.materialIconName ? (
            <div className={classes.rowBody} style={{ flexDirection: 'column', marginRight: 10, marginTop: 0 }}>
              {CUSTOM_ACTION_BUTTONS_ICONS.find(icon => icon.value === customField.materialIconName)?.displayIconComponent}
            </div>
          ) : null}
          <h4 className={classes.rowTitle} style={{ margin: 0, fontSize: 18 }}>{customField.name || customField.title}</h4>
          </div>
          {customField.action ? (
            <div className={classes.rowBody} style={{ flexDirection: 'column' }}>
              {renderActionDescription()}
            </div>
          ) : null}
        </div>
        <IconButton
          onClick={onHandleDeleteClick}
          style={{ padding: 8 }}
        >
          <DeleteIcon style={{ color: RED, fontSize: 22 }} />
        </IconButton>
      </div>
    </Card>
  );
};

class CustomExploreButtonListView extends React.Component {
  render() {
    const { customExploreButtonsData, pagination, onRowClick, onCreateNew, onDeleteClick, onLoadMoreEvents, classes } = this.props;
    const customExploreButtonsPagination = {
      number: 0,
      totalPages: 1,
    };
    return (
      <div className={classes.container}>
        <InfiniteScroll
          initialLoad={false}
          loadMore={() => onLoadMoreEvents(number + 1)}
          hasMore={customExploreButtonsPagination.number + 1 < customExploreButtonsPagination.totalPages}
          useWindow={false}
          loader={
            <div style={{ marginTop: 20, backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingVertical: 5, }}>
              <h4 style={{ textAlign: 'center', color: '#3f3f3f' }}><Entity entity="loadingLogs" /></h4>
              <CircularProgress className={classes.circularProgress} />
            </div>
          }
        >
          <div>
            {!_.isEmpty(customExploreButtonsData) ?
              _.map(customExploreButtonsData, (customField) =>
                <CustomFieldRow
                  key={customField.id}
                  customField={customField}
                  classes={classes}
                  onRowClick={() => onRowClick(customField)}
                  onDeleteClick={onDeleteClick}
                />)
                : (
                  <div>
                    <EmptyCustomFieldsView
                      onCreateNew={() => onCreateNew()}
                    />
                  </div>
                )
              }
          </div>
        </InfiniteScroll>
      </div>
    );
  }

}
export default withStyles(styles)(CustomExploreButtonListView);